exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fade-enter-active,.fade-leave-active{transition:opacity .3s}.fade-enter,.fade-leave-to{opacity:0}.color-picker-wrap .color-placeholder{max-width:225px;border:1px solid #abc0d1;height:50px;display:flex;align-items:center;border-radius:25px;padding-left:20px;padding-right:4px;justify-content:space-between}.color-picker-wrap .color-placeholder p{margin:0;color:#abc0d1}.color-picker-wrap .color-placeholder button{width:42px;height:42px;display:block;border-radius:50%;border:0}.color-picker-wrap .vc-chrome{margin-top:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0b287f28","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/fields/color-picker.vue
// module id = 69
// module chunks = 0